export const ja = {
    // Header
    'header.title': '🎭 キーン暴露',
    'header.subtitle': 'Tom Kean Jr. (NJ-7) — あなたの医療保険を気にしていません。',

    // Hero Section
    'hero.quote': 'Tom Kean Jr.: "有権者には独立派だと言っています。そしてMAGAと投票します。"',
    'hero.subtext': '4人の共和党員がACA補助金を守るために党に反旗しました。12月17日、4人のGOP議員が勇気を示し、投票を強制するために民主党と協力しました。Tom Kean Jr. (NJ-7)？彼は沈黙したままでした。12月、ケアンはACA補助金の延長を求める共和党の呼びかけに、17人の共和党上院議員とともに名前を連ねました――しかし下院共和党とともに延長を阻止する投票をしました。2,200万人のアメリカ人が1月1日から114%の保険料上昇に直面します。',

    // Breaking News
    'breaking.news': '🚨 速報：Bloomberg：米国人はガソリンや食料品より医療費を心配',

    // Kean Did Not Support Section
    'kean.betrayal.title': 'TOM KEAN JR.はあなたのために立ち上がることを拒否しました',
    'kean.betrayal.text': '12月17日、接戦地区からの4人の共和党員（Brian Fitzpatrick、Rob Bresnahan Jr.、Ryan MackenzieはPAから、Mike LawlerはNYから）が党に反旗し、ACA補助金延長に関する投票を強制するために民主党と協力しました。Tom Kean Jr.下院議員(NJ-7)はその一人ではありませんでした。彼はあなたの医療保険よりも党への忠誠を選びました。',
    'kean.betrayal.comparison': 'この4人の共和党員は勇気を示しました。キーンは臆病さを示しました。',
    'kean.betrayal.cta': 'キーンに聞いてください：なぜ私たちのために立ち上がらなかったのですか？',

    // Healthcare Context Section
    'context.title': '共和党はあなたの医療保険を気にしていません：「医療費の津波」は今まさに到来',
    'context.intro': '共和党下院議員Tom Kean Jr. (NJ-7)はあなたの医療保険のために何もしていません。保険料、診察料、処方薬など、すべてにもっと支払う準備をしてください。どうやって払うつもりですか？12月16日、下院共和党がACA補助金延長の民主党の努力を否決しました。民主党はあなたの医療保険のために戦ってきました — ACAを可決し、主要な薬の処方薬価格を下げるなど。しかしTom Kean Jr.は党に従ってこれらの保護が期限切れになるよう投票しました。',
    'context.truth.title': '真実：NJ家族への実際の影響',
    'context.truth.text': 'NJ州マーワーの住民Tina Jumpは、ACA保険料が<strong>月400ドルから1,100ドル以上</strong>に — ほぼ3倍に急騰することを知りました。「どうやって払えばいいのかわかりません」と彼女はCBS Newsに語りました。',
    'context.impact': '税額控除を受ける資格のある<strong>2,200万人のアメリカ人</strong>が厳しい財政的決断に直面しています。自己負担の保険料コストは<strong>平均114%上昇</strong>し、年間コストが1,016ドル増加します。年収75,000ドルの4人家族は追加で<strong>3,368ドル</strong>の保険料上昇を見る可能性があります。',
    'context.tsunami': '「1月1日に医療費が急増する津波を見ることになるでしょう」とCommunity CatalystのMichelle Sternthalは言いました。議会予算局によると、高い保険料のために約<strong>400万人が健康保険を解約</strong>する可能性があります。',
    'context.exposed.title': '暴露：最も脆弱な人は誰か？',
    'context.exposed.text': '中小企業経営者と自営業者が特にリスクにさらされています。ACAに登録している成人の約半数は中小企業経営者、25人未満の従業員の会社で雇用されている人、または自営業者です。',
    'context.accountability': 'Tom Kean Jr.下院議員(NJ-7)は党に従ってこれらの補助金が期限切れになるよう投票しました。民主党議員はACA保険料税額控除の延長に関する投票を強制するための請願書を回覧しています。下院を勝ち取る道はニュージャージーを直接通ります。彼に責任を取らせる時です。',
    'context.cta': '今すぐ行動',

    // ACA Section
    'aca.title': '共和党があなたの医療保険を奪っています — ACA補助金は12月31日に失効しました',
    'aca.text': '下院共和党は12月16日にACA補助金の延長を阻止しました。1月1日から、保険料は平均114%急騰します。年収72,000ドルのマーワー住民のような一部の家族は、コストがほぼ3倍 — 月400ドルから1,100ドル以上に増加します。Tom Kean Jr.下院議員(NJ-7)はこの命綱を阻止するために党に従って投票しました。',
    'aca.chart.title': '平均保険料上昇',
    'aca.chart.2025': '2025',
    'aca.chart.2026': '2026',
    'aca.chart.withSubsidies': '補助金あり',
    'aca.chart.increase': '+114% 平均',

    // No Kean Day Section
    'nokean.title': 'ノー・キーン・デー！',
    'nokean.date': '2月7日',
    'nokean.message': '彼にメッセージを送ろう！',
    'nokean.standup': '医療保険のために立ち上がれ',
    'nokean.handle': '@CongressmanKean',
    'nokean.caption': '「鏡が不快なのでタウンホールを避けています。」',

    // Voting Record Section
    'voting.title': '📜 領収書は明確',
    'voting.record.title': 'Tom Kean Jr.の投票記録',
    'voting.bill.name': 'H.R.1 - 一つの大きく美しい法案',
    'voting.bill.congress': '第119議会 (2025-2026) | 公法 119-21',
    'voting.bill.rollcall': '点呼投票 #145 | 2025年5月22日',
    'voting.bill.cut1': '• ACA補助金削減 - 174%の保険料上昇を引き起こす',
    'voting.bill.cut2': '• NJ家族に影響するメディケイド資金削減',
    'voting.breakdown.title': '投票内訳',
    'voting.breakdown.yeas': '✓ 賛成：215（全員共和党）',
    'voting.breakdown.nays': '✗ 反対：214（全員民主党）',
    'voting.breakdown.present': '出席：1',
    'voting.breakdown.notvoting': '不投票：2',
    'voting.breakdown.passed': '可決',
    'voting.kean.name': 'TOM KEAN JR.',
    'voting.kean.title': '下院議員、NJ-7',
    'voting.kean.vote': '賛成',
    'voting.kean.result': '医療保険削減に投票',
    'voting.source': '出典：米国下院書記官室 | clerk.house.gov/Votes/2025145',
    'voting.cta.vote': 'Keanの投票を見る',
    'voting.cta.bill': '法案を読む (H.R.1)',

    // Medicaid Section
    'medicaid.title': 'Tom Kean Jr.: 「私はこれを「財政責任」と呼んでいます」',
    'medicaid.text': 'Tom Kean Jr.下院議員(NJ-7)は、高齢者、子供、障害者を脅かすメディケイド削減を支持しました。これらの削減は医師、病院、長期ケアへのアクセスを減らします。すべての投票が真実を語ります — 彼が語らなくても。',
    'medicaid.visual': 'メディケイド = 命綱',
    'medicaid.hashtags': '#キーン暴露 #金を追え',
    'medicaid.hashtags.text': '#キーン暴露 #金を追え #共和党は医療保険を気にしない',

    // Medicare Section
    'medicare.title': 'Tom Kean Jr.: 「声を失ったのではありません。トランプに渡しました。」',
    'medicare.subtext': '共和党の提案には数千億ドルのメディケア削減が含まれています。Tom Kean Jr.下院議員(NJ-7)はこれらの努力に同調し、高齢者の医療保険を脅かしています。',
    'medicare.bullet1': 'GOP予算案は4,790億ドルのメディケア削減を提案しています（支払い構造、資格変更）。',
    'medicare.bullet2': '「一つの大きく美しい法案」にはメディケアアクセスを制限する条項が含まれていました。',
    'medicare.bullet3': 'NJ-7の高齢者は病院訪問、処方薬、長期ケアのためにメディケアに依存しています。',
    'medicare.cta': 'メディケアを守れ — 行動を起こせ',
    'medicare.visual': 'メディケア = 命綱。\nQRコードをスキャンして行動しましょう。',

    // Accountability Section
    'accountability.title': '仮面が剥がれた。Tom Kean Jr.に責任を取らせよう。',
    'accountability.text': '「時には沈黙は金ではありません。慎重さを装った臆病です。」Tom Kean Jr.下院議員(NJ-7)の記録は明確です：より高いコスト、より少ないケア、より多くの困難。NJ-7はもっと良いものに値します。',
    'accountability.cta': '#キーン探し金曜日に参加',

    // News Sources Section
    'news.title': '📰 もっと領収書',
    'news.updated': '2026年1月29日更新',
    'news.cbs': 'CBS News：数百万人が保険料急騰に直面',
    'news.wsj': 'WSJ：メディケア支払い据え置きに保険会社が反応',
    'news.bloomberg': 'Bloomberg：医療費が最も大きな不安',
    'news.nytimes': 'NY Times：4人の共和党員が投票を強制するために党に反旗',
    'news.nytimes2': 'NY Times：下院、オバマケア補助金延長を阻止',
    'news.nytimes3': 'NY Times：共和党員が民主党の提案をフィニッシュラインまで推進',

    // Footer
    'footer.tagline': '真実は痛い。嘘はもっと高くつく。共和党はあなたの医療保険を気にしていません。',
    'footer.hashtags': '#キーン暴露 #王様はいない #共和党は医療保険を気にしない',
    'footer.disclaimer': '真実は痛い。嘘はもっと高くつく。共和党はあなたの医療保険を気にしていません。#キーン暴露 #王様はいない #共和党は医療保険を気にしない',
    'footer.terms': '利用規約',
    'footer.privacy': 'プライバシーポリシー',
    'footer.contact': 'お問い合わせ',
};

export default ja;
